import React from 'react';
import { Link } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import { SERVICES_LIST } from '../servicedata';


const  WhyChooseUs = () => {
  const navigate = useNavigate();


  return (
    <section className="why-us py-10 bg-white">
      <div className="container">
        <div className="why-us-inner">
          <div className="section-title mb-6 text-center">
            <h6 className="green text-uppercase fw-bold mb-2">Why Choose Us</h6>
            <h2 className="w-lg-50 m-auto fw-bold">
              Best Electric <span className="green">Service Provider</span> for the EV Ecosystem
            </h2>
          </div>

          <div className="section-body">
            <div className="row gy-4">
              {SERVICES_LIST.map((item) => (
                <div key={item.id} className="col-lg-4 col-md-6 d-flex">
                  <div className="service-box d-flex align-items-center p-4 border border-2 bg-white border-lightgreen rounded-4 shadow-sm hover-lift transition-all">
                    <div className="service-icon me-4 flex-shrink-0">
                      <img
                        src={item.icon}
                        alt={item.title}
                        style={{ width: '100px', height: '100px' }}
                      />
                    </div>
                    <div className="service-info">
                      <h4 className="mb-1 fw-bold">
                        <Link className="text-dark text-decoration-none">
                          {item.title}
                        </Link>
                      </h4>
                      <p className="small text-muted mb-0">
                        {item.desc}
                      </p>
                      <button
                        className="btn btn-success px-6 py-2 mt-4 rounded-pill"
                        onClick={() => navigate(item.path)}
                      >
                        Learn More <span>&rarr;</span>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;